// Lets navigation triggers outside the Dashboard (sidebar/header links) ask it
// to close its expanded widget and unwind the synthetic history entry it
// pushed for Back-button handling, before the navigation's own history push
// lands on top of that entry and strands it.
//
// closeDashboardWidgetForNavigation is async-aware: if a widget is open, the
// unwind is a real history.back() (the only way to actually remove the
// synthetic entry rather than just relabel it), which only resolves once the
// browser's popstate confirms it. Callers must defer their navigation to the
// onReady callback rather than firing it immediately.
let closer = null;

export const registerDashboardWidgetCloser = (fn) => {
  closer = fn;
};

export const unregisterDashboardWidgetCloser = (fn) => {
  if (closer === fn) closer = null;
};

export const closeDashboardWidgetForNavigation = (onReady) => {
  if (closer) {
    closer(onReady);
  } else if (onReady) {
    onReady();
  }
};
